export enum Channel {
  Mobile = 'MOBILE',
  Web = 'WEB'
}
